module.exports = __webpack_public_path__ + "img/ea8cf0cbed7ab7be554c8cd6f2623d72_副本_副本.ad2133d8.jpg";